if (!customElements.get('ace-category-navigation')) {
  customElements.define('ace-category-navigation', class extends HTMLElement {
    connectedCallback() {
      this.disclosure = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.section = this.closest('.shopify-section');
      this.header = document.querySelector('.section-header');
      this.announcement = document.querySelector('.ace-member-announcement-section');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.close = () => { if (this.disclosure) this.disclosure.open = false; };
      this.setupPickers(options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.disclosure?.open && !event.target.closest?.('select')) {
          event.preventDefault();
          this.close();
          this.summary?.focus({ preventScroll: true });
        }
      }, options);
      this.addEventListener('click', (event) => {
        if (event.target.closest?.('a')) this.close();
      }, options);
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) this.close();
      }, options);
      window.addEventListener('pageshow', this.close, options);
      this.updateOffset = () => {
        const visibleStickyHeader = this.header && this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
        const bandHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ace-sticky-announcement-height')) || 0;
        const announcement = document.querySelector('.ace-member-announcement-section');
        const bandBottom = announcement ? Math.max(0, announcement.getBoundingClientRect().bottom) : bandHeight;
        const headerBottom = visibleStickyHeader ? Math.max(0, this.header.getBoundingClientRect().bottom) : 0;
        this.section?.style.setProperty('--ace-category-header-offset', `${Math.max(bandBottom, headerBottom)}px`);
        if (window.matchMedia('(min-width: 990px)').matches) this.close();
      };
      window.addEventListener('resize', this.updateOffset, options);
      document.addEventListener('ace:announcement-resize', this.updateOffset, options);
      this.trackHeader = () => {
        this.headerFrame = 0;
        this.updateOffset();
        if (this.headerMoving) this.headerFrame = requestAnimationFrame(this.trackHeader);
      };
      this.onHeaderTransition = (event) => {
        if (event.target !== this.header || !['top', 'transform'].includes(event.propertyName)) return;
        this.headerMoving = event.type === 'transitionrun';
        this.updateOffset();
        if (this.headerMoving && !this.headerFrame) this.headerFrame = requestAnimationFrame(this.trackHeader);
      };
      if (this.header) {
        this.headerObserver = new MutationObserver(this.updateOffset);
        this.headerObserver.observe(this.header, { attributes: true, attributeFilter: ['class'] });
        this.sizeObserver = new ResizeObserver(this.updateOffset);
        this.sizeObserver.observe(this.header);
        if (this.announcement) this.sizeObserver.observe(this.announcement);
        ['transitionrun', 'transitionend', 'transitioncancel'].forEach((name) => this.header.addEventListener(name, this.onHeaderTransition, options));
      }
      this.close();
      this.updateOffset();
    }
    collectionUrl(value) {
      if (!value || typeof value !== 'string') return '';
      try {
        const url = new URL(value, window.location.origin);
        return url.origin === window.location.origin && /\/collections\/[^/]+\/?$/.test(url.pathname)
          ? `${url.pathname}${url.search}` : '';
      } catch {
        return '';
      }
    }
    setupPickers(options) {
      const templates = new Map(Array.from(this.querySelectorAll('template[data-category-options]'), (template) => [template.dataset.categoryOptions, template]));
      this.pickers = Array.from(this.querySelectorAll('[data-category-picker]')).map((form) => ({
        form,
        parent: form.querySelector('[data-category-parent]'),
        child: form.querySelector('[data-category-child]'),
        button: form.querySelector('button[type="submit"]')
      })).filter((picker) => picker.parent && picker.child && picker.button);
      if (!templates.size || !this.pickers.length) return;
      this.pickers.forEach((picker) => {
        picker.placeholder = picker.child.options[0]?.cloneNode(true) || new Option('', '');
        picker.parent.addEventListener('change', () => this.selectParent(picker.parent.value, templates), options);
        picker.child.addEventListener('change', () => {
          this.pickers.forEach((other) => {
            other.child.value = picker.child.value;
            other.button.disabled = !this.collectionUrl(other.child.value);
          });
        }, options);
        picker.form.addEventListener('submit', (event) => {
          event.preventDefault();
          const url = this.collectionUrl(picker.child.value);
          if (!url || picker.child.disabled || picker.button.disabled) return;
          this.close();
          window.location.assign(url);
        }, options);
        picker.form.hidden = false;
      });
      this.selectParent('', templates);
      this.querySelectorAll('[data-category-fallback]').forEach((list) => { list.hidden = true; });
    }
    selectParent(value, templates) {
      this.pickers.forEach((picker) => {
        picker.parent.value = value;
        const template = templates.get(value);
        picker.child.replaceChildren(template ? template.content.cloneNode(true) : picker.placeholder.cloneNode(true));
        Array.from(picker.child.options).forEach((option) => {
          option.disabled = !this.collectionUrl(option.value);
        });
        picker.child.selectedIndex = 0;
        picker.child.disabled = !template || !Array.from(picker.child.options).some((option) => !option.disabled);
        picker.button.disabled = picker.child.disabled || !this.collectionUrl(picker.child.value);
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.headerObserver?.disconnect();
      this.sizeObserver?.disconnect();
      this.headerMoving = false;
      cancelAnimationFrame(this.headerFrame);
    }
  });
}


